import ActionLink from "components/ActionLink";
import { useAlertDialog, useConfirm } from "common/hooks";
import { useUpdateAnalysisAsync } from "containers/hooks";

export default function DeleteMapLink({ analysis }) {
    const alert = useAlertDialog();
    const confirm = useConfirm();
    const updateAnalysisAsync = useUpdateAnalysisAsync(analysis);

    const analysisIsSpatiallyMapped = analysis?.features?.length > 0;
    if (!analysisIsSpatiallyMapped)
        return null;

    const deleteMap = () => {
        const hasDrawnIrrigators = analysis.features.some(f => f.properties.layer === "Irrigator");
        if (hasDrawnIrrigators) {
            alert("You cannot delete this map because the analysis has irrigation systems that have also been spatially mapped. You must unmap these irrigation systems first.");
        } else {
            confirm(`Are you sure you want to delete the map of this farm? This will only delete the map for this analysis.`, async () => {
                const updatedAnalysis = {
                    ...analysis,
                    features: []
                };
                await updateAnalysisAsync(updatedAnalysis);
            });
        }
    };

    return (
        <>
            <ActionLink id="delete-map" className="IconLink--trash" onClick={deleteMap}>
                Delete farm map
            </ActionLink>
        </>
    )
}
